var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more",on:{"click":function($event){return _vm.$emit('toggleFold')}}},[_c('span',[_vm._v(_vm._s(_vm.fold ? '展开全部' : '点击收起'))]),_c('fc-icon',{class:{ up: !_vm.fold },attrs:{"type":"32_down"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }